/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: ButtonPlay.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  08.07.22 12:38 pm.
 * Last modified: 08.07.22 12:38 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { useTranslator } from '../contexts/TranslatorContext';

const ButtonPlay = ({ onClick }: IButtonPlayProps) => {
    const translate = useTranslator();

    return (
        <div className="egt_game_btn_play">
            <div className="buttonContainer">
                <button className="btnPlay" onClick={() => onClick?.()}>
                    {translate('Play')}
                </button>
            </div>
        </div>
    );
};

export interface IButtonPlayProps {
    onClick?: () => void;
}

export default ButtonPlay;
